<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('common_habit') }} <span class="text-10-400 color-27 ri-ps-2 ri-pe-3">{{
            ss.getFormattedDate(data.dateString, 'EEE, d MMM') }}</span></h6>
    <div class="flex items-center gap-6">
        <!-- Comments: not deleted, >= 375px -->
        @if (!deleted() && screenWidth() >= 375) {
        <app-svg name="commonMenuComment" (click)="openMessage()" role="button" [color]="ss.theme().color12" width="18"
            height="18"></app-svg>
        }

        <!-- Kebab: not deleted -->
        @if (!deleted()) {
        <app-svg name="topbarKebabDot" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button"
            [color]="ss.theme().color12" width="18" height="18"></app-svg>
        }

        <!-- Close: always last -->
        <app-svg name="topBarClose" role="button" (click)="closeDialog()" width="18" height="18"></app-svg>

        <!-- Kebab menu content -->
        <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu">

            <!-- Comments: mobile only (<375px), overflows from top bar -->
            @if (screenWidth() < 375) { <button mat-menu-item (click)="openMessage()">
                <span class="flex items-center text-14-400 color-8 gap-3">
                    <app-svg name="kebabMenucomment" class="icon-mirror-rtl" [color]="ss.theme().color35" height="14"
                        width="14" role="button"></app-svg>
                    {{ ss.t('comments_titleTopBar') }}
                </span>
                </button>
                }

                @if(habitType() === 'timer' && setup().timerGoal && role() === 'owner'){
                <button mat-menu-item (click)="openCompletionAlert()">
                    <span class="flex items-center text-14-400 color-8 gap-3"><app-svg name="sound"
                            class="icon-mirror-rtl" [color]="ss.theme().color35" role="button" height="14"
                            width="14"></app-svg>{{
                        ss.t('soundSelect_titleTopBar')
                        }}</span>
                </button>
                }


                <!-- Edit Setup: always in kebab -->
                <button mat-menu-item (click)="editSetup()">
                    <span class="flex items-center text-14-400 color-8 gap-3">
                        <app-svg name="kebabMenuEdit" class="icon-mirror-rtl" height="14" width="14"
                            [color]="ss.theme().color35" role="button" height="14" width="14"></app-svg>
                        {{ ss.t('actionCommon_editSetup') }}
                    </span>
                </button>

                <!-- Reset Entry: non-viewers only -->
                @if (role() !== 'viewer') {
                <button mat-menu-item (click)="resetHabit()">
                    <span class="flex items-center text-14-400 color-8 gap-3">
                        <app-svg name="reset" [color]="isFormHasValue() ? ss.theme().color11 : ss.theme().color4"
                            role="button" height="14" width="14"></app-svg>
                        {{ ss.t('common_resetEntry') }}
                    </span>
                </button>
                }

                <!-- Delete Entry: owner, invalid entry only -->
                @if (role() === 'owner' && !isValidEntry()) {
                <button mat-menu-item (click)="deleteHabit()">
                    <span class="flex items-center text-14-400 color-8 gap-3">
                        <app-svg name="commonMenutrash" height="14" width="14" [color]="ss.theme().color11"
                            role="button"></app-svg>
                        {{ ss.t('common_deleteEntry') }}
                    </span>
                </button>
                }

                <!-- Delete All Invalid: owner, invalid entry only -->
                @if (role() === 'owner' && !isValidEntry()) {
                <button mat-menu-item (click)="deleteAllInvalidEntries()">
                    <span class="flex items-center text-14-400 color-8 gap-3">
                        <app-svg name="commonMenutrash" height="14" width="14" [color]="ss.theme().color11"
                            role="button"></app-svg>
                        {{ ss.t('common_deleteAllInvalidEntries') }}
                    </span>
                </button>
                }

        </mat-menu>
    </div>
</div>
<div class="habit-form" id="habitContentBlock" [ngClass]="{'deleted-habit': deleted()}">
    <div (click)="role() === 'viewer' || deleted() ? ds.noAccess($event) : null">
        <p class="text-14-400 color-12 mb-0 ri-px-4 ri-py-2 bg-29 flex items-center justify-between"
            *ngIf="remindingDays() !== null && !isHideRemainingDays() && this.cc.today() === data.dateString">
            <span>{{ remindingDays() | parseRemainingDays }}</span>
            <span role="button" (click)="isHideRemainingDays.set(true)">{{ ss.t('common_dismiss') }}</span>
        </p>
        <p class="text-14-400 color-14 mb-0 ri-px-4 ri-py-2 bg-28 text-center" *ngIf="!isValidEntry()">{{
            ss.t('actionCommon_invalidEntry') }}</p>
        <form [formGroup]="habitForm" class="gap-6 flex flex-col ri-p-4" #haForm="ngForm"
            [ngClass]="{'readonly' : role() === 'viewer' || deleted(), 'blocked' : deleted()}">
            <p class="color-8 text-18-500 mb-0 w-full text-center">{{ setup().title }}</p>
            <div class="boolean-block" *ngIf="habitType() === 'boolean'">
                <button class="btn-boolean text-16-400"
                    (click)="getFc('booleanAnswer').value === true ? getFc('booleanAnswer').setValue(null) : getFc('booleanAnswer').setValue(true)"
                    [ngClass]="{'active' : getFc('booleanAnswer').value === true }">
                    <span>{{ ss.t('common_yes') }}</span>
                    <span class="check-circle"></span>
                </button>
                <button class="btn-boolean text-16-400"
                    (click)="getFc('booleanAnswer').value === false ? getFc('booleanAnswer').setValue(null) : getFc('booleanAnswer').setValue(false)"
                    [ngClass]="{'active' : getFc('booleanAnswer').value === false }">
                    <span>{{ ss.t('common_no') }}</span>
                    <span class="check-circle"></span>
                </button>
            </div>
            <div class="options-block" *ngIf="habitType() === 'single' || habitType() === 'multiple'">
                <button class="btn-option text-16-400" *ngFor="let option of setup().habitOptions"
                    [ngClass]="{'active' : getFc('singleAnswer').value === option.id || (habitType() === 'multiple' && getFc('multipleAnswer').value && getFc('multipleAnswer').value.includes(option.id)) }"
                    (click)="selectOption(option.id)">
                    <span>{{ option.value }}</span>
                    <span class=""
                        [ngClass]="{'check-circle' : habitType() === 'single', 'checkmark' : habitType() === 'multiple'}"></span>
                </button>
            </div>
            <div class="progress-block" *ngIf="habitType() === 'timer'">
                <div class="flex justify-center ri-pb-4">
                    <div class="circular-progress" [style.background]="progressColor()">
                        <ng-container *ngFor="let angle of divisionAngles()">
                            <div class="circular-division absolute left-1/2 top-1/2 w-[1.5px] h-[calc(50%+1px)] origin-top"
                                [ngStyle]="{ transform: 'rotate(' + angle + 'deg)' }" *ngIf="roundCount() > 1">
                            </div>
                        </ng-container>
                        <div class="progress-value">
                            <span class="text-14-400 color-8 block text-center"
                                [ngClass]="{'hidden' : duration().totalSeconds === 0}">{{ totalTimePercentage()
                                }}%</span>
                            <span class="text-24-500 color-8 block ri-py-4 text-center">{{ (totalSecondsSpent() +
                                timerSeconds()) | timeFormat
                                }}</span>
                            <span class="text-14-400 color-7 flex items-center justify-center ri-px-4" dir="ltr"
                                [ngClass]="{'hidden' : duration().totalSeconds === 0}">
                                <span class="ri-pe-1">{{ duration().totalSeconds | timeFormat }}</span>
                                <span>x {{ setup().roundCount }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="value-block flex items-center justify-between" *ngFor="let value of reversedTimerAnswers()">
                    <span class="text-14-400 color-8" *ngIf="value.startedAt && value.endedAt">{{
                        value.startedAt | timeFormat:value.endedAt
                        }}</span>
                    <div class="flex items-center">
                        <span class="text-14-400 color-7 ri-pe-4">{{ ss.getFormattedDate(value.startedAt, 'h:mm a')
                            }}</span>
                        <app-svg name="trash" [color]="ss.theme().color7" width="18" height="18" role="button"
                            (click)="deleteTimerValue(value)"></app-svg>
                    </div>
                </div>
            </div>
            <div class="progress-block" *ngIf="habitType() === 'numeric'">
                <div class="flex justify-center ri-pb-4">
                    <div class="circular-progress" [style.background]="progressColor()">
                        <div class="progress-value">
                            <span class="text-24-500 color-8 block ri-py-4 text-center">{{ totalNumericValue() }}</span>
                            <span class="text-14-400 color-7 block text-center ri-px-4">{{ setup().numericGoal ?
                                ss.t('habitActionHabitTypeNumericalValue_withGoal', { target:
                                setup().numericGoal + ' ' + setup().numericUnit }) : setup().numericUnit }}</span>
                        </div>
                    </div>
                </div>
                <div class="value-block flex items-center justify-between"
                    *ngFor="let value of reversedNumericAnswers()" (click)="addNumericValue(value)" role="button">
                    <span class="text-14-400 color-8">{{ value.value }} {{ setup().numericUnit }}</span>
                    <div class="flex items-center">
                        <span class="text-14-400 color-7 ri-pe-4">{{ ss.getFormattedDate(value.recordedAt, 'h:mm a')
                            }}</span>
                        <app-svg name="trash" [color]="ss.theme().color7" width="18" height="18" role="button"
                            (click)="$event.stopPropagation();deleteNumericValue(value)"></app-svg>
                    </div>
                </div>
            </div>
            <app-input-text-editor [maxLength]="20000" *ngIf="isDescription" [control]="getFc('description')"
                name="meHabitDescription" [placeholder]="ss.t('common_description')" [readonly]="role() === 'viewer'"
                [accessAlert]="true" [blocked]="deleted()" [defaultValue]="habitInitial.description"
                (focusEvent)="editorFocused.set($event)" (formatEvent)="activeFormats.set($event)"
                (dropdownPositionEvent)="onDropdownPosition($event)"></app-input-text-editor>
            <app-input-hashtag *ngIf="role() === 'owner'" [control]="getFc('tags')" [setupHashtags]="setup().tags"
                [blocked]="deleted()" [screenWidth]="screenWidth()" [defaultTagIds]="setup().tags || []"
                (tagsChanged)="onHashtagsChanged($event)"
                (activeChanged)="hashtagInputActive.set($event)"></app-input-hashtag>
            <div *ngIf="habitType() !== 'timer' && habitType() !== 'numeric'"></div>
            <p class="text-14-400 color-7 text-end"
                *ngIf="mode() === 'edit' && isCollab() && !hasChanges() && !deleted()">{{ getLastUpdatedByText() }}</p>
        </form>

    </div>


    <div class="habit-addons ri-px-4">
        @if(!deleted()){
        <div class="add-button flex items-center justify-between"
            [ngClass]="{'timer-started' : habitType() === 'timer' && timerState()}" *ngIf="isAddFab()">
            <div class="timer-second ri-ps-4 whitespace-nowrap" *ngIf="habitType() === 'timer'">
                <span class="text-14-400 color-12 block text-center">{{ timerSeconds() | timeFormat }} <span
                        [ngClass]="{'hidden' : duration().totalSeconds === 0 || roundCompleteSecondsLeft() === 0}">/ {{
                        roundCompleteSecondsLeft() | timeFormat }}</span></span>
            </div>

            <button class="btn ms-auto"
                (click)="habitType() === 'numeric' ? addNumericValue() : timerState() ? stopTimer() : startTimer()">
                <app-svg [ngClass]="!timerState() ? 'icon-mirror-rtl' :''"
                    [name]="habitType() === 'numeric' ? 'plus' : timerState() ? 'pause' : 'play'" width="18"
                    height="18"></app-svg>
            </button>

        </div>
        }

    </div>

    <div class="habit-addons-inner"
        [ngClass]="{'ri-pb-4' : (attachmentValues && attachmentValues.length > 0) || (mode() === 'edit' && isCollab() && !hasChanges() && !deleted())}">
        <app-attachment-list class="ri-pt-4" [title]="setup().title"
            *ngIf="attachmentValues && attachmentValues.length > 0" [attachments]="attachmentValues"
            (deleteEvent)="deleteAttachments($event)" [entityId]="habitInitial.id" [entityName]="'habit'"
            [uid]="habitInitial.uid" [blocked]="deleted()" [viewOnly]="role() === 'viewer'"
            [blocked]="deleted()"></app-attachment-list>
    </div>
</div>
<div class="bottom-section flex items-center justify-between ri-p-4 text-end ri-bt-2" *ngIf="!deleted()">
    <div class="flex items-center">
        <!-- Mobile toolbar (desktop uses floating toolbar inside editor) -->
        <app-text-editor-options *ngIf="cc.isNarrowScreen() && editorFocused()" [activeFormats]="activeFormats()"
            [position]="dropdownPosition()" (closeEvent)="onToolbarClose($event)"
            (editOptionsEvent)="editOptions($event.opt, $event.value)"></app-text-editor-options>
        <div class="flex items-center gap-8">
            <app-svg *ngIf="!isDescription && role() !== 'viewer'" name="description" class="icon-mirror-rtl"
                [color]="ss.theme().color35" width="18" height="18" role="button" (click)="addDescription()"></app-svg>
            <app-svg
                *ngIf="role() === 'owner' && (!getFc('tags').value || getFc('tags').value.length === 0) && !hashtagInputActive()"
                name="hashtag" [color]="ss.theme().color35" width="18" height="18" role="button"
                (click)="activateHashtagInput()"></app-svg>
            <app-input-file [attachments]="newAttachments" [multiple]="true"
                [entityOwnerUid]="setup().uid" *ngIf="role() !== 'viewer'"></app-input-file>
        </div>
    </div>
    <button type="submit" class="btn-text text-16-500 color-35" (click)="hasChanges() ? save() : closeDialog()">{{
        hasChanges() ? ss.t('common_save') : ss.t('common_close') }}</button>
</div>